var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var PROPERTY_OWNERSHIP = ['RENT', 'OWNED'];
export var NUMBER_OF_PREVIOUS_CLAIMS = [
    'NONE',
    'ONE',
    'TWO',
    'THREE',
    'MORE_THAN_THREE',
];
export var TERMINATION_PARTIES = [
    'MYSELF',
    'INSURER',
    'STILL_ACTIVE',
];
export var YEARS_SINCE_LAST_CLAIM = [
    'LESS_THAN_ONE_YEAR',
    'ONE_YEAR',
    'TWO_YEARS',
    'THREE_OR_MORE_YEARS',
];
export var EMPLOYMENT_STATUSES = [
    'EMPLOYED',
    'SELF_EMPLOYED',
    'STUDENT',
    'LOOKING_FOR_JOB',
    'CIVIL_PUBLIC_SERVANT',
    'RETIRED',
    'UNKNOWN_PROFESSION',
    // Legacy
    'JOB_SEARCHING',
    'FREELANCER',
];
export var FAMILY_STATUSES = ['FAMILY', 'SINGLE'];
export var PLANS = ['BASIC', 'ADVANCED'];
export var insurers = [
    'ACE Automobil Club e.V.',
    'ADAC',
    'ADLER',
    'AdvoCard',
    'AIG EUROPE S.A. Paris',
    'AIOI Motor and General',
    'Allianz',
    'Allrecht',
    'Alte Leipziger',
    'A+M Versicherung',
    'ARAG',
    'Aspecta Versicherung AG',
    'Asstel',
    'AUXILIA',
    'AVD',
    'AXA',
    'AXA Alternative',
    'Baden-Badener',
    'BGV Badische Versicherungen',
    'Badische Gemeinde',
    'Basler',
    'Basler Securitas ROLAND',
    'Bayerische Beamten Versicherung',
    'Bayerische Hausbesitzer',
    'die Bayerische',
    'Bruderhilfe',
    'Concordia',
    'Condor Allgemeine',
    'Die Continentale',
    'Cosmos',
    'DA Deutsche Allgemeine',
    'D.A.S.',
    'DBV',
    'DBV-Winterthur',
    'Debeka',
    'Deurag',
    'DFV',
    'Deutsche Internet',
    'Deutscher Herold Allgemeine',
    'DEVK',
    'DEVK (Sach/HUK)',
    'Direct Line',
    'DMB',
    'EUROPA',
    'Europe Assistance',
    'Feather',
    'Frankfurter Versicherungs AG (Frankfurter Allianz)',
    'GARANTA Versicherungs-AG',
    'GVO',
    'Getsafe (Roland)',
    'Generali Lloyd',
    'Generali',
    'Gerling-Konzern Allgemeine',
    'Gothaer Allgemeine Versicherungs AG',
    'GVV',
    'Hamburg Mannheimer',
    'Hanse Merkur Versicherung',
    'HDI Privat Versicherung AG',
    'HDI',
    'Helvetia (Schweizerische Versicherungsgesellschaft)',
    'Hiscox AG (Niederlassung für die Bundesrepublik Deutschland)',
    'HUK Coburg',
    'HUK24',
    'HUK-COBURG',
    'Ideal',
    'Ineas Insurance Company NV',
    'InterLloyd',
    'Itzehoer',
    'Jurpartner',
    'Karlsruher Beamten-Versicherung AG',
    'Karlsruher',
    'KRAVAG-SACH',
    'KS Kraftfahrer-Schutz',
    'Laeisz',
    'Landesschadenhilfe',
    'Lippische Landes-Brandversicherungsanstalt',
    'LVM',
    'Mannheimer Versicherung AG',
    'Mecklenburgische',
    'Medien Versicherung',
    'Merkur Assistance AG Holding',
    'Minerva',
    'Münchener Verein',
    'Neckermann Versicherungen',
    'NRV',
    'SIGNAL IDUNA',
    'Nürnberger Versicherung',
    'Öffentliche Feuerversicherung Sachsen-Anhalt',
    'ÖVB',
    'Oldenburgische Landesbank AG',
    'Oldenburgische Landesbrandkasse',
    'Optima Versicherung-AG',
    'ÖRAG',
    'OVAG',
    'Provinzial Nord Brandkasse',
    'Provinzial Versicherungsanstalt der Rheinprovinz',
    'Quelle Versicherung AG',
    'Rechtsschutz Union',
    'Rheinland Versicherungs AG',
    'Roland',
    'ROLAND Schutzbrief-Versicherung AG',
    'R+V',
    'SAARLAND Feuerversicherung AG',
    'SCHWEIZER-NATIONAL',
    'Sicher Direkt Roland',
    'Sparkassen-Versicherung Sachsen',
    'Sparkassen DirektVersicherung',
    'SV SparkassenVersicherung Hessen-Nassau-Thüringen',
    'Telcon Versicherung AG',
    'Transatlantische Allgemeine Versicherung AG',
    'Ülzener Allgemeine',
    'Vereinte Spezial Versicherung AG',
    'VGH Versicherungen',
    'VHV',
    'Volksfürsorge Deutsche Lebensversicherung AG',
    'Volkswohl Bund Versicherungen',
    'Westfälische Provinzial Versicherung',
    'Württembergische Gemeinde-Versicherung',
    'Württembergische und Badische',
    'Württembergische',
    'Württembergische Versicherungen',
    'Zurich',
];
var assertedInsurers = __spreadArray([], insurers, true);
